import angular from 'angular'

function NominasCfdiEmpresa($filter, $http) {
  let $filterDate = $filter('date');
  let schema = {
    colaboradores: 'number',
    fecha_inicial: 'date',
    fecha_final: 'date',
    nominas: {
      fecha_inicial: 'date',
      fecha_final: 'date',
    },
  };

  this.get = function (idEmpresa, fechaInicial, fechaFinal) {
    return $http.get('/api/nominas/cfdi/empresa', {
      params: {
        id_empresa: idEmpresa,
        fecha_inicial: $filterDate(fechaInicial, 'yyyy-MM-dd'),
        fecha_final: $filterDate(fechaFinal, 'yyyy-MM-dd'),
      },
      schema: schema,
    });
  };
}

angular.module('nominas.cfdi')
  .service('NominasCfdiEmpresa', NominasCfdiEmpresa);



// WEBPACK FOOTER //
// ./src/nominas/cfdi/services/NominasCfdiEmpresa.js